export const formatDate = (x, options = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
}) => {
    const formatter = new Intl.DateTimeFormat(undefined, options);
    return formatter.format(new Date(x));
};
